import { render, staticRenderFns } from "./MediaInfo.vue?vue&type=template&id=23ffd923&scoped=true"
import script from "./MediaInfo.vue?vue&type=script&lang=ts"
export * from "./MediaInfo.vue?vue&type=script&lang=ts"
import style0 from "./MediaInfo.vue?vue&type=style&index=0&id=23ffd923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffd923",
  null
  
)

export default component.exports